export enum PresetType {
	PresetId = 'preset-id',
	PresetNumber = 'preset-number',
	None = 'none',
}

export function getProviderPresetType(providerName: string): PresetType {
	if (['PGHARD', 'JOKERHARD'].includes(providerName)) return PresetType.PresetId
	if (providerName.startsWith('HARDV2')) return PresetType.PresetNumber
	return PresetType.None
}

export function isRtpSupportedProvider(providerName: string): boolean {
	return getProviderPresetType(providerName) !== PresetType.None
}
